const ButtonStyles = `
  .editorial button {
    background: none;
    border: none;
  }

  .editorial .nts-button {
    background-color: var(--nts-white);
    border: 1px solid var(--nts-white);
    color: var(--nts-black);
    font-size: 16px;
    font-weight: bold;
    line-height: 18px;
    padding: 13px 24px;
    text-transform: uppercase;
    text-decoration: none;
    transition: color 0.1s;
  }

  .editorial .nts-button:hover,
  .editorial .nts-button:focus {
    background-color: var(--nts-grey-light);
    border-color: var(--nts-grey-light);
  }

  .editorial .nts-button:disabled {
    background-color: var(--nts-grey-dark);
    border-color: var(--nts-grey-dark);
  }

  .editorial .nts-button--alt {
    background-color: var(--nts-black);
    border: 1px solid var(--nts-grey-mid-dark);
    color: var(--nts-white);
    padding: 13px 24px;
  }

  .editorial .nts-button--alt:hover,
  .editorial .nts-button--alt:focus {
    background-color: var(--nts-black);
    border-color: var(--nts-grey-mid-dark);
    color: var(--nts-grey-mid-light);
  }

  .editorial .nts-button--alt:hover svg,
  .editorial .nts-button--alt:focus svg {
    fill: var(--nts-grey-mid-light);
  }

  .editorial .nts-button--alt svg {
    fill: var(--nts-white);
  }

  .editorial .nts-button--alt:disabled {
    background-color: var(--nts-black);
    border-color: var(--nts-grey-dark);
    color: var(--nts-grey-dark);
  }

  .editorial .nts-button--alt:disabled svg {
    fill: var(--nts-grey-dark);
  }

  .editorial .nts-button--outline {
    background-color: transparent;
    color: var(--nts-white);
  }
`

export default ButtonStyles
